export enum RetirementType {
  SIMPLE,
  EPHESO,
  ANIA,
}
